import { useTranslation } from "react-i18next";
import Logo from "assets/images/logo-dark.png";

// Full-screen branded loader. Ditampilkan selama data inits (/WA/inits) sedang
// dimuat — mis. setelah login atau saat refresh dalam keadaan sudah login.
// Teks default diambil dari i18n (resource lokal yang di-bundle, tersedia sejak
// boot — tidak menunggu login); bisa di-override lewat prop title/subtitle.
const PageLoader = ({ title, subtitle }) => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white px-6">
      <img
        src={Logo}
        alt="Kledo"
        className="mb-10 w-40 select-none"
        draggable={false}
      />
      <span
        role="status"
        aria-label="Memuat"
        className="mb-6 h-9 w-9 animate-spin rounded-full border-[3px] border-gray-200 border-t-primary"
      />
      <h1 className="mb-1 text-lg font-semibold text-gray-700">
        {title ?? t("loader.preparing_workspace")}
      </h1>
      <p className="max-w-xs text-center text-sm text-gray-400">
        {subtitle ?? t("loader.preparing_workspace_desc")}
      </p>
    </div>
  );
};

export default PageLoader;
